import { useCallback, useEffect, useState } from 'react'
import { useNavigate, useParams } from 'react-router-dom'

import {
  useContainerTypeActions,
  useContainerTypeById,
  useWarehouseStock,
} from 'services/warehouse-containers/containers'
import { Loading } from 'components/ui/Loading/Loading'
import { Button } from 'components/ui/Button/Button'
import { Slider } from 'components/ui/Slider/Slider'
import { ContainerTypeOverview } from 'components/ContainerTypeOverview/ContainerTypeOverview'

import './overview.style.css'

export const ContainersOverview = () => {
  const navigate = useNavigate()
  const { containerTypeId } = useParams()
  const [amount, setAmount] = useState<{ value: number; diff: number }>({ value: 0, diff: 0 })
  const [isActive, setIsActive] = useState<boolean>(false)

  const { args } = useWarehouseStock()
  const { isLoading: isProcessing, addContainers, removeContainers } = useContainerTypeActions()
  const { isLoading, containerType } = useContainerTypeById(containerTypeId)

  useEffect(() => {
    if (!containerType) return

    const diff = containerType.amount.total - containerType.amount.used

    setAmount({ value: diff, diff })
  }, [containerType])

  const renderText = useCallback(() => {
    const diff = Math.abs(amount.value - amount.diff)

    if (amount.value > amount.diff) {
      return (
        <span>
          Удалить <b>{diff}</b> контейнер(ов) <b>"{containerType?.name}"</b> со склада?
        </span>
      )
    }

    return (
      <span>
        Добавить <b>{diff}</b> контейнер(ов) <b>"{containerType?.name}"</b> на склад?
      </span>
    )
  }, [amount.value, amount.diff])

  const handleOnSubmit = () => setIsActive(true)

  const handleOnChange = (value: number) => setAmount((prev) => ({ ...prev, diff: value }))

  const handleOnSliderSubmit = async () => {
    if (amount.value === amount.diff) {
      navigate(-1)

      return
    }

    const f = amount.value > amount.diff ? removeContainers : addContainers

    await f(args.id, containerTypeId, Math.abs(amount.value - amount.diff))

    setIsActive(false)
    navigate(-1)
  }

  const handleOnSliderClose = () => {
    setIsActive(false)
  }

  if (isLoading || isProcessing) return <Loading />

  return (
    <>
      <ContainerTypeOverview
        containerType={containerType}
        value={amount.diff}
        disabled={amount.diff === amount.value}
        onChange={handleOnChange}
        onSubmit={handleOnSubmit}
      />
      <Slider isActive={isActive} height="180px" onClose={handleOnSliderClose}>
        <div className="container-overview__slider">
          <h2>Подтвердите действие</h2>
          <span>{renderText()}</span>
          <div className="container-overview__slider-controlls">
            <span style={{ marginRight: '0.5rem' }}>
              <Button title="Подтвердить" handleOnSubmit={handleOnSliderSubmit} />
            </span>
            <Button outline title="Отмена" handleOnSubmit={handleOnSliderClose} />
          </div>
        </div>
      </Slider>
    </>
  )
}
